/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */


import React, { memo, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Button, ButtonIcon, MoneyInput, TextInput, Popover } from 'diginet-core-ui/components';
import Config from '../../../../config/index';
import { Column } from "devextreme-react/data-grid";
import { Lookup } from 'devextreme-react/lookup';
import GridContainer from "../../../grid-container/grid-container";
import { makeStyles } from '@material-ui/core/styles';
import * as W06F0009Actions from '../../../../redux/W0X/W06F0009/W06F0009_actions';
import { useDispatch } from 'react-redux';
import SelectIDNameModal from "../../../common/selectIDNameModal/SelectIDNameModal";
import GridActionBar from '../../../grid-container/grid-actionbar';
import { AddItem } from 'diginet-core-ui/icons';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    distance: {
        marginBottom: 10,
        width: '100%',
    },
    divHeaderTitle: {
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontSize: '12px',
        textTransform: 'uppercase',
        color: '#8F9BB3',
        paddingRight: 10,
    },
    divHeaderItem: {
        fontWeight: '600',
        fontStyle: 'normal',
        color: '#222B45',
        fontSize: 16
    },
    numberFormatInput: {
        backgroundColor: 'transparent',
        margin: '0 !important',
        paddingLeft: 10,
        paddingRight: 5
    },
    specPopup: {
        '& div.MuiFilledInput-root': {
            height: 210,
            paddingRight: '2px !important',
            '& textarea': {
                height: '100%'
            }
        }
    },
    specPopupMobile: {
        '& .MuiFilledInput-root': {
            height: 170,
            paddingRight: '2px !important',
            '& textarea': {
                height: '100%'
            }
        }
    },
    ellipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    specCell: {
        display: 'flex',
        alignItems: 'center',
        width: '-webkit-fill-available'
    },
    textarea: {
        '& .outlined': {
            border: '1px solid #7F828E !important',
            boxShadow: 'none !important',
            '&:after': {
                border: 'none !important'
            }
        }
    }
}));


const TabInventory = memo(forwardRef((props, ref) => {
    const {
        formData, decimalQuantity, ExchangeRate, numberFormat,
        cellRenderNumber, mode, onSetIsUpdate, TransTypeID, CurrencyID } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState({ rows: [], total: 0 });
    const [arrColumn, setArrColumn] = useState([]);
    const [showInventorySelect, setShowInventorySelect] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    // const countSaleItemID = useRef(0);
    const cbUnitTemp = useRef({});
    const [cbUnit, setCbUnit] = useState({});
    const loadCboUnit = useRef(false);
    const [cbMarking, setCbMarking] = useState([]);
    const [cbPackingMethod, setCbPackingMethod] = useState([]);
    const [cbPackingType, setCbPackingType] = useState([]);
    const [cbPaymentTerm, setCbPaymentTerm] = useState([]);
    const selectedRange = useRef(null);
    const dataGrid = useRef(null);
    const popover = useRef(null);
    const inputRef = useRef(null);
    const rowData = useRef(null);
    const oldDataInventory = useRef(JSON.stringify([]));
    const countSaleItemID = useRef(0);

    const [arrColumnFilter, setArrColumnFilter] = useState([]);

    useImperativeHandle(ref, () => ({
        onSave, onCreateSaveHistory
    }))

    useEffect(() => {
        getDetailSupplement();
        getCboMarking();
        getCboPackingMethod();
        getCboPackingType();
        getCboPaymentTerm();
        /* eslint-disable */
    }, [])

    useEffect(() => {
        if (arrColumn.length > 0) {
            getDataDisplay();
        }
        /* eslint-disable */
    }, [TransTypeID, arrColumn])

    useEffect(() => {
        if (formData) {
            if (formData.rows.length > 0) {
                let fieldDat = Object.keys(formData.rows[0]);
                fieldDat = fieldDat.filter(rs => rs.substring(0, 3) === 'Dat')
                fieldDat.forEach(field => {
                    formData.rows.map(item => {
                        if (item[field]) {
                            item[field] = moment(item[field]).format('YYYY-MM-DD');
                        }
                        return item;
                    });
                });
            }
            setDataSource(formData);
            countSaleItemID.current = formData.rows.length + 1;
            if (mode !== 'add') {
                oldDataInventory.current = JSON.stringify(formData.rows);
            }
            loadCboUnit.current = false;
        }
        /* eslint-disable */
    }, [formData])

    const getDataDisplay = () => {
        dispatch(W06F0009Actions.getDataDisplay(null, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            const displayName = "Display";
            const rowDataTransType = data.find(rs => rs.TransTypeID === TransTypeID);
            if (rowDataTransType) {
                const activeInventoryColumn = arrColumn.filter((item) => {
                    const defaultData = rowDataTransType["Default" + item.FieldName];
                    if (item.FieldName.includes("Str") && item.FieldName.includes("U")) {
                        item.FieldName = item.FieldName.slice(0, -1);
                        item.DefaultValueU = defaultData;
                    } else if (item.FieldName.includes("Dat")) {
                        item.DefaultValueU = defaultData ? moment(defaultData).format('YYYY-MM-DD') : null;
                    } else {
                        item.DefaultValueU = defaultData;
                    }
                    return rowDataTransType[displayName.concat(item.FieldName)] === 1;
                });
                setArrColumnFilter(activeInventoryColumn);
            }
        }));
    }

    const getDetailSupplement = () => {
        dispatch(W06F0009Actions.getDetailSupplement({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            if (data?.length > 0) {
                // const dataFilter = data.filter(rs => Number(rs.DisplayOrder) === 1);
                // data.map(rs => {
                //     const FieldName = rs.FieldName.slice(0, parseInt("-" + (rs.FieldName.length - 3).toString()));
                //     if (FieldName === 'Dat') {
                //         rs.DefaultValueU = moment(rs.DefaultValueU, 'DD/MM/YYYY').format('YYYY-MM-DD');
                //     }
                //     return rs;
                // })
                setArrColumn(data);
            }
        }));
    }

    const getCboMarking = () => {
        dispatch(W06F0009Actions.getCboMarking({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbMarking(data);
        }));
    }

    const getCboPackingType = () => {
        dispatch(W06F0009Actions.getCboPackingType({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbPackingType(data);
        }));
    }

    const getCboPackingMethod = () => {
        dispatch(W06F0009Actions.getCboPackingMethod({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbPackingMethod(data);
        }));
    }

    const getCboPaymentTerm = () => {
        dispatch(W06F0009Actions.getCboPaymentTerm({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            setCbPaymentTerm(data);
        }));
    }

    const getCboUnit = (InventoryID, cb) => {
        dispatch(W06F0009Actions.getCboUnit({ InventoryID }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("Loi_chua_xac_dinh");
                Config.popup.show("DANGER", message);
                return false;
            }
            cbUnitTemp.current = { ...cbUnitTemp.current, [InventoryID]: data };
            if (cb) cb(cbUnitTemp.current);
        }));
    }

    const renderColumn = () => {
        const rs = arrColumnFilter.map((item, i) => {
            const { Caption } = item;
            let { FieldName } = item;
            let fieldType = "string";
            let formatDate = "";
            let alignment = "left";
            const width = Caption.length > 20 ? 200 : 150;
            const limitFieldName = FieldName.slice(0, parseInt("-" + (FieldName.length - 3).toString()));
            switch (limitFieldName) {
                case "Num":
                    fieldType = "number";
                    alignment = "right";
                    break;
                case "Dat":
                    fieldType = "date";
                    alignment = "center";
                    formatDate = "dd/MM/yyyy";
                    break;
                case "Str":
                    fieldType = "string";
                    break;
                default:
                    break;
            }
            return (
                <Column
                    key={i}
                    caption={Caption}
                    dataField={FieldName}
                    dataType={fieldType}
                    format={formatDate}
                    width={width}
                    alignment={alignment}
                    {...(limitFieldName === "Dat" ? {
                        editorOptions: {
                            placeholder: "DD/MM/YYYY",
                            dateSerializationFormat: 'yyyy-MM-dd'
                        }
                    } : {})
                    }
                />
            )
        });
        return rs;
    }

    const renderButtonAction = (e, mode) => {
        return (
            Config.isMobile ?
                renderIconAction(e)
                : <GridActionBar>
                    {renderIconAction(e)}
                </GridActionBar>
        );
    };

    const renderIconAction = (e) => {
        return (
            <ButtonIcon
                size='tiny'
                name="delete"
                viewType="text"
                onClick={() => onRowDelete(e)}
            />
        );
    };

    const onRowDelete = (e) => {
        e.component.deleteRow(e.rowIndex);
        setLabelTotal();
        onSetIsUpdate();
    }

    const openModal = () => {
        setShowInventorySelect(!showInventorySelect);
    }

    const onSelectedInventory = (dataSelected) => {
        dataSelected.forEach(item => {
            arrColumnFilter.forEach(rs => {
                item[rs.FieldName] = rs.DefaultValueU;
            });
            const _SubPurchaseItemID = countSaleItemID.current++;
            item["Quantity"] = 0;
            item["UnitPrice"] = 0;
            item["PackingMethodID"] = "";
            item["PackingTypeID"] = "";
            item["MarkingID"] = "";
            item["PaymentTermID"] = "";
            item["SubPurchaseItemID"] = String(_SubPurchaseItemID);
        });
        setDataSource({ ...dataSource, rows: [...dataSource.rows, ...dataSelected] });
        loadCboUnit.current = false;
        onSetIsUpdate();
        openModal();
    }

    useEffect(() => {
        setLabelTotal();
        /* eslint-disable */
    }, [dataSource])

    const onRowUpdate = (e) => {
        const { oldData, newData } = e;
        const calculatingField = ["Quantity", "UnitPrice", "UnitID"];
        const columnName = (Object.keys(newData))[0];
        const { DeployQuantity } = oldData;
        if (calculatingField.includes(columnName)) {
            let changedQuantityStatus = false;
            if (newData.Quantity && DeployQuantity) {
                if (DeployQuantity === 0) {
                    changedQuantityStatus = true;
                } else {
                    if (newData.Quantity < DeployQuantity) {
                        Config.popup.show("DANGER", `${Config.lang("ERP_Ban_khong_duoc_sua_so_luong_hang_hoa_nho_hon_so_luong_dang_trien_khai_la")} ${DeployQuantity}`);
                        newData.Quantity = oldData.Quantity;
                    } else {
                        changedQuantityStatus = true;
                    }
                }
            } else {
                changedQuantityStatus = true;
            }
            if (changedQuantityStatus || columnName === "UnitID") mathAmountValue(e);
        }
    }

    const mathAmountValue = (e) => {
        if (e) {
            const { newData, oldData } = e;
            const Quantity = newData.Quantity || oldData.Quantity;
            const UnitPrice = newData.UnitPrice || oldData.UnitPrice;
            const ConversionFactor = newData.ConversionFactor || oldData.ConversionFactor || 0;
            newData.OAmount = Quantity * UnitPrice;
            newData.CAmount = Quantity * UnitPrice * ExchangeRate;
            newData.CQuantity = Quantity * ConversionFactor;
        }
        setLabelTotal();
    }

    const sumValue = (arr, key) => {
        return arr.reduce((a, b) => a + (b[key] || 0), 0);
    }

    const setLabelTotal = () => {
        if (!dataGrid.current) return false;
        const _dataSource = dataGrid.current.instance.option("dataSource");
        const refOTotal = document.querySelector('#OTotal');
        const refCTotal = document.querySelector('#CTotal');
        const _oTotal = sumValue(_dataSource, 'OAmount');
        const _cTotal = sumValue(_dataSource, 'CAmount');
        refOTotal.innerHTML = numberFormat(_oTotal, _.get(decimalQuantity, 'OriginalDecimal'));
        if (refCTotal) refCTotal.innerHTML = numberFormat(_cTotal, _.get(decimalQuantity, 'ConvertedDecimal'));
    }

    const showEditSpecPopup = (evt, cellData) => {
        if (!cellData) return false;
        rowData.current = cellData;
        if (popover.current) {
            popover.current.setPosition(evt.currentTarget);
            popover.current.show();
            setTimeout(() => {
                inputRef.current.value = cellData.value;
                inputRef.current.focus();
            }, 300);
        }
    };

    const cellRenderPopupAction = (cellData) => {
        const dataField = cellData.column.dataField,
            rowData = cellData.data;
        return (
            <div className={`${classes.specCell} pull-left mgr5`} onClick={(e) => mode !== 'view' && showEditSpecPopup(e, cellData)}>
                {mode !== 'view' &&
                    <ButtonIcon className={'btn_edit_spec'} viewType='text'
                        size='tiny' name="menu" onClick={(e) => showEditSpecPopup(e, cellData)}>
                    </ButtonIcon>
                }
                <div className={`${classes.ellipsis} pull-left textCellHidden`} title={rowData[dataField]}>{rowData[dataField]}</div>
            </div>
        );
    }

    const onSaveInput = () => {
        if (rowData.current) {
            const { rowIndex } = rowData.current;
            dataGrid.current.instance.cellValue(rowIndex, "Specification", inputRef.current.value);
            dataGrid.current.instance.saveEditData();
            popover.current.close();
        }
    }

    const createSave = async (newData, oldData, options) => {
        if (!(newData && oldData && typeof newData === typeof oldData)) return false;
        if (!options) return false;
        if (!newData && !oldData) return false;
        const { keyExpr, mode } = options || {};
        let data = {
            added: [],
            edited: [],
            removed: []
        };
        // let keys = [];
        let dataType = newData ? Array.isArray(newData) ? "array" : (typeof newData === "object" ? "object" : null) : null;
        dataType = dataType ? dataType : (oldData ? Array.isArray(oldData) ? "array" : (typeof oldData === "object" ? "object" : null) : null);
        switch (dataType) {
            case "array":
                //Array..
                newData = newData ? newData : [];
                oldData = oldData ? oldData : [];
                const newDataKeys = newData.map(d => d[keyExpr]);
                const oldDataKeys = oldData.map(d => d[keyExpr]);
                const added = newData.filter(d => oldDataKeys.indexOf(d[keyExpr]) <= -1);
                const edited = newData.filter(d => oldDataKeys.indexOf(d[keyExpr]) > -1);
                const removed = oldData.filter(d => newDataKeys.indexOf(d[keyExpr]) <= -1);
                //Added..
                if (!mode || mode.length < 1 || mode.indexOf("add") > -1) {
                    added.forEach(item => {
                        data.added.push(item);
                    });
                }
                //Edited..
                if (!mode || mode.length < 1 || mode.indexOf("edit") > -1) {
                    edited.forEach(item => {
                        if (item.IsUpdated === 1) {
                            data.edited.push(item)
                        }
                    });
                }
                //Removed..
                if (!mode || mode.length < 1 || mode.indexOf("remove") > -1) {
                    removed.forEach(item => {
                        data.removed.push(item);
                    });
                }
                break;
            default:
                break;
        }
        return await data;
    };

    const onSave = async () => {
        dataGrid.current.instance.saveEditData();
        const _dataSource = dataGrid.current.instance.option("dataSource");
        let dataSave = _dataSource;
        if (mode === 'edit') {
            const option = {
                keyExpr: "SubPurchaseItemID",
                mode: ["add", "edit", "remove"],
                excludeFields: '',
            };
            const oldData = JSON.parse(oldDataInventory.current);
            dataSave = await createSave(_dataSource, oldData, option);
        }
        return JSON.stringify(dataSave);

    }

    const getCodeLangInventory = () => {
        const inventory = {
            UnitID: 'Don_vi_tinh', Quantity: 'So_luong', UnitPrice: 'Gia',
            PackingMethodID: 'Quy_cach_dong_goi', PackingTypeID: 'Loai_bao_dong_goi',
            ParkingDeliveryDate: 'Thoi_gian_giao_hang', PaymentTermID: 'Dieu_khoan_thuong_mai',
            Specification: 'Tieu_chuan_chat_luong',
            // OAmount: 'Thanh_tien', CAmount: 'Thanh_tien_qd',
        };
        arrColumnFilter.forEach(rs => {
            inventory[rs.FieldName] = rs.Caption;
        });
        return inventory;
    }

    const getOptions = (SubContractID) => {
        const options = {
            codeID: SubContractID,
            keyExpr: "SubPurchaseItemID",
            formID: "W06F0009",
            mode: ["add", "edit", "remove"],
            excludeFields: ["IsUpdated", "OAmount", "CAmount"],
            itemRender: (e, type) => {
                const { mode, data, captions, dataField } = e;
                if (mode === "addGrid") {
                    if (type === "description84") return Config.lang('Hang_hoa', 'vi');
                    if (type === "description01") return Config.lang('Hang_hoa', 'en');
                    if (type === "newValue") return data.InventoryID;
                }
                if (mode === "editGrid") {
                    if (type === "description84") return Config.lang(captions[dataField], "vi") + ' ' + Config.lang('Hang_hoa', 'vi') + ' ' + data.InventoryID + ' ' + data.InventoryNameU;
                    if (type === "description01") return Config.lang(captions[dataField], "en") + ' ' + Config.lang('Hang_hoa', 'en') + ' ' + data.InventoryID + ' ' + data.InventoryNameU;
                }
                if (mode === "removeGrid") {
                    if (type === "description84") return Config.lang('Hang_hoa', 'vi');
                    if (type === "description01") return Config.lang('Hang_hoa', 'en');
                    if (type === "oldValue") return data?.InventoryID + ' - ' + data?.InventoryNameU;
                }
            }
        };
        return options;
    }

    const onCreateSaveHistory = async (SubContractID) => {
        const _dataSource = dataGrid.current.instance.option("dataSource");
        const oldData = JSON.parse(oldDataInventory.current);
        const options = getOptions(SubContractID);
        const data = await Config.createSaveHistory(_dataSource, oldData, getCodeLangInventory(), options, true);
        return data;
    }

    return (
        <div>
            {showInventorySelect && <SelectIDNameModal
                formID={"W06F0002"}
                maxWidth={"sm"}
                modalType={"Inventory"}
                selectedRow={selectedRow}
                openModal={showInventorySelect}
                selectedRowKeys={(e) => setSelectedRow(e)}
                onChosen={onSelectedInventory}
                onClose={openModal}
            />}
            <Popover
                ref={ref => popover.current = ref}
                width={window.innerWidth < 576 ? '100%' : 580}
                height={290}
            >
                <div className="pd10">
                    <TextInput
                        label={Config.lang('Tieu_chuan_chat_luong')}
                        className={`(${!(window.innerWidth < 576) ? classes.specPopup : classes.specPopupMobile} ${classes.textarea}`}
                        rows={8}
                        multiline
                        viewType="outlined"
                        inputRef={inputRef} />
                    <div className={"pull-right"} >
                        <Button viewType='filled' size='small' startIcon="save" color='info' label={Config.lang("Luu")} onClick={onSaveInput} />
                    </div>
                </div>
            </Popover>

            <div className={`${classes.distance} display_row align-center align-between flex-wrap`}>
                {mode !== 'view' &&
                    <Button viewType="outlined" startIcon={<AddItem width={20} color={"primary"} size="small" />} color='primary'
                        label={Config.lang("Them_hang_hoa")} onClick={openModal} />
                }
                <div className="display_row align-center flex-wrap">
                    <div style={{ paddingRight: 30 }}>
                        <label className={classes.divHeaderTitle}>{Config.lang("Gia_tri_hop_dong")}:</label>
                        <span id="OTotal" className={`${classes.divHeaderItem}`}>0</span>
                    </div>
                    {CurrencyID !== 'VND' &&
                        <div >
                            <label className={classes.divHeaderTitle}>{Config.lang("Gia_tri_hop_dong_QD")}:</label>
                            <span id="CTotal" className={`${classes.divHeaderItem}`}>0</span>
                        </div>
                    }
                </div>
            </div>

            <GridContainer
                reference={ref => dataGrid.current = ref}
                dataSource={dataSource.rows}
                hoverStateEnabled={true}
                showColumnLines={false}
                columnAutoWidth={true}
                showRowLines={false}
                showBorders={false}
                typePaging="normal"
                pagerFullScreen={false}
                keyExpr={"SubPurchaseItemID"}
                columnResizingMode={"widget"}
                typeShort={window.innerWidth < 768}
                elementAttr={{ class: `noBGSelect`, style: 'min-height: 300px' }}
                height={"calc(100vh - 250px)"}
                editing={{
                    mode: "cell",
                    refreshMode: "reshape",
                    allowUpdating: mode !== 'view',
                    texts: {
                        confirmDeleteMessage: "",
                    },
                }}
                onContentReady={(e) => {
                    if (!loadCboUnit.current) {
                        loadCboUnit.current = true;
                        const _dataSource = e.component.option("dataSource");
                        // setCbUnit({ ...cbUnit, [InventoryID]: data });
                        _dataSource.forEach((d, i) => {
                            if (!cbUnit.hasOwnProperty(d.InventoryID)) {
                                getCboUnit(d.InventoryID, (cbU) => {
                                    setCbUnit(cbU);
                                });
                            }
                        });
                    }
                }}
                onRowUpdating={(e) => onRowUpdate(e)}
                onRowUpdated={(e) => {
                    onSetIsUpdate();
                    if (mode === 'edit') e.data.IsUpdated = 1;
                }}
                onKeyDown={(e) => {
                    Config.onEnterAndTabKeyNavigation(e, selectedRange.current, dataGrid.current,
                        (rowIndex) => selectedRange.current.startRowIndex = rowIndex
                        , (columnIndex) => selectedRange.current.startColumnIndex = columnIndex);
                }}
                onCellSelectionChanged={(e) => {
                    if (e.selectedRange) selectedRange.current = e.selectedRange;
                }}
            >
                <Column caption={Config.lang('Ma_hang')} dataField={'InventoryID'} allowEditing={false} width={150}
                    fixed={!Config.isMobile} />
                <Column caption={Config.lang('Ten_hang')} dataField={'InventoryNameU'} allowEditing={false} width={150}
                    fixed={!Config.isMobile} />
                <Column dataField={'ConversionFactor'} allowEditing={false} width={150}
                        visible={false} />
                <Column caption={Config.lang('Don_vi_tinh')} dataField={'UnitID'} width={150}
                    cellRender={(e) => {
                        const { data } = e;
                        const _dataCboUnit = cbUnit[data.InventoryID];
                        const Unit = _dataCboUnit && _dataCboUnit.find(cboUnit => cboUnit.UnitID === data.UnitID);
                        return Unit && Unit.UnitName;
                    }}
                    editCellRender={(e) => {
                        const { data } = e;
                        return <Lookup
                            dataSource={cbUnit[data.InventoryID]}
                            valueExpr={"UnitID"}
                            height={24}
                            displayExpr={"UnitName"}
                            value={data.UnitID}
                            placeholder={Config.lang("Chon") + "..."}
                            onValueChanged={l => {
                                if (l.value === data["UnitID"]) return;
                                const dataSource = l.component.option("dataSource");
                                const item = dataSource.find(d => d.UnitID === l.value);
                                e.component.cellValue(e.rowIndex, e.columnIndex, l.value);
                                e.component.cellValue(e.rowIndex, "ConversionFactor", item?.["ConversionFactor"] || 0);
                            }}
                        />
                    }}
                />
                <Column caption={Config.lang('So_luong')} dataField={'Quantity'} width={150}
                    cellRender={(e) => cellRenderNumber(e)}
                    editCellRender={(e) => {
                        return (
                            <MoneyInput
                                thousandSeparator={','}
                                value={e.value}
                                className={classes.numberFormatInput}
                                nonStyle
                                decimalDigit={_.get(decimalQuantity, 'QuantityDecimals', 5)}
                                allowZero
                                onChange={(c) => e.setValue(Number(c.value))}
                            />
                        )
                    }}
                />
                <Column caption={Config.lang('So_luong_QD')} dataField={'CQuantity'} width={150}
                        cellRender={(e) => cellRenderNumber(e)}  allowEditing={false}
                />
                <Column caption={Config.lang('Gia')} dataField={'UnitPrice'} width={150}
                    cellRender={(e) => cellRenderNumber(e)}
                    editCellRender={(e) => {
                        return (
                            <MoneyInput
                                thousandSeparator={','}
                                value={e.value}
                                className={classes.numberFormatInput}
                                nonStyle
                                decimalDigit={_.get(decimalQuantity, 'UnitPriceDecimals', 3)}
                                allowZero
                                onChange={(c) => e.setValue(Number(c.value))}
                            />
                        )
                    }} />
                <Column caption={Config.lang('Thanh_tien')} dataField={'OAmount'} allowEditing={false} width={150}
                    cellRender={(e) => cellRenderNumber(e, _.get(decimalQuantity, 'OriginalDecimal', 3))} />
                <Column caption={Config.lang('Thanh_tien_qd')} dataField={'CAmount'} allowEditing={false} width={150}
                    cellRender={(e) => cellRenderNumber(e, _.get(decimalQuantity, 'ConvertedDecimal', 3))}
                    visible={CurrencyID !== 'VND'} />
                <Column caption={Config.lang('Quy_cach_dong_goi')} dataField={'PackingMethodID'} width={150}
                    lookup={{
                        dataSource: cbPackingMethod,
                        valueExpr: "PackingMethodID",
                        displayExpr: "PackingMethodName",
                    }}
                    editorOptions={{
                        placeholder: Config.lang("Chon") + "...",
                    }} />
                <Column caption={Config.lang('Loai_bao_dong_goi')} dataField={'PackingTypeID'} width={250}
                    lookup={{
                        dataSource: cbPackingType,
                        valueExpr: "PackingTypeID",
                        displayExpr: "PackingTypeName",
                    }}
                    editorOptions={{
                        placeholder: Config.lang("Chon") + "...",
                    }} />
                <Column caption={Config.lang('Thoi_gian_giao_hang')} dataField={'ParkingDeliveryDate'} width={150}
                    dataType="date" format="dd/MM/yyyy" alignment="center" visible={false} />
                <Column caption={Config.lang('Nhan_mac')} dataField={'MarkingID'} width={250}
                    lookup={{
                        dataSource: cbMarking,
                        valueExpr: "MarkingID",
                        displayExpr: "MarkingName",
                    }}
                    editorOptions={{
                        placeholder: Config.lang("Chon") + "...",
                    }}
                    visible={false}
                />
                <Column caption={Config.lang('Dieu_khoan_thuong_mai')} dataField={'PaymentTermID'} width={200}
                    lookup={{
                        dataSource: cbPaymentTerm,
                        valueExpr: "PaymentTermID",
                        displayExpr: "PaymentTermName",
                    }}
                    editorOptions={{
                        placeholder: Config.lang("Chon") + "...",
                    }}
                    visible={false} />
                {renderColumn()}
                <Column caption={Config.lang('Tieu_chuan_chat_luong')} dataField={'Specification'}
                    allowEditing={false}
                    cellRender={cellRenderPopupAction}
                    width={220} />
                <Column
                    fixed={true}
                    alignment={"right"}
                    fixedPosition={"right"}
                    allowEditing={false}
                    visible={!Config.isMobile && mode !== 'view'}
                    cellRender={(e) => renderButtonAction(e)}
                />
            </GridContainer>
        </div>
    );
}));

export default TabInventory;
